import { NodeSection } from "../props/node/constants";
import { sizeToPixel } from "../props/adaptive/utils";
export var ObtainNodeInfoVisitor = {
  Node: {
    enter: function enter(path, state) {
      state.currentNodeId = path.params.nodeId;
    },
    enterChild: function enterChild(path) {
      if (path.params.section !== NodeSection.CHILDREN) this.skip();
    }
  },
  AdaptiveDecorator: {
    enterChild: function enterChild(path, state) {
      if (path.params.matchesInterval(state.opts)) {
        state.currentMaxSize = path.params.maxSize;
      } else this.skip();
    }
  },
  ListOfIdentifiers: function ListOfIdentifiers(path, state) {
    var nodeId = state.opts.nodeId;
    var currentNodeId = state.currentNodeId;
    var value = path.node.value;

    // Если задана параметризация, то мы используем те значения, которые сейчас видит пользователь,
    // поэтому из всех интервалов мы выбираем самое высокое разрешение
    var isBestChildrenSize = sizeToPixel(state.currentMaxSize) > sizeToPixel(state.maxChildrenSize);
    if (currentNodeId === nodeId && isBestChildrenSize) {
      state.children = value;
      state.maxChildrenSize = state.currentMaxSize;
    }
    var isBestParentMatch = sizeToPixel(state.currentMaxSize) > sizeToPixel(state.maxParentSize);
    var index = value.indexOf(nodeId);
    if (index !== -1 && isBestParentMatch) {
      state.beforeId = value[index + 1];
      state.afterId = value[index - 1];
      state.parentId = currentNodeId;
      state.maxParentSize = state.currentMaxSize;
    }
  }
};